import ajax from './ajax';

export function getJobLocations() {
  return ajax('/joblocations?sort=-id&per-page=1000&page=1');
}
